/** Returns true for non-null object values that can be read by string key. */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/** Deep-clones JSON-like renderer records so callers can enrich by replacement. */
export function cloneRecord<TRecord extends Record<string, unknown>>(record: TRecord): TRecord {
  // SAFETY: cloneValue preserves the record's key/value shape while recursively copying child arrays/records.
  return cloneValue(record) as TRecord;
}

/** Reads a string field from a dynamic renderer/API record. */
export function stringField(record: Record<string, unknown>, key: string): string | undefined {
  const value = record[key];
  return typeof value === 'string' ? value : undefined;
}

function cloneValue(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(cloneValue);
  if (isRecord(value)) {
    return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, cloneValue(child)]));
  }
  return value;
}
